<template>
  <div>
    <v-card class="pa-2 d-print-none">
      <v-row no-gutters class="align-center">
        <v-col
          cols="12"
          md="9"
          class="d-flex"
          :class="$vuetify.breakpoint.mobile ? 'flex-column' : ''"
        >
          <div class="align-self-start">
            <v-btn
              small
              class="white black--text d-print-none"
              @click="$printReport()"
            >
              <v-icon small left>mdi-printer</v-icon>
              {{ $t("print") }}
            </v-btn>
          </div>
        </v-col>
        <v-col cols="12" md="3">
          <v-text-field
            :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('search')"
            single-line
            hide-details
            dense
            solo-inverted
            clearable
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card>

    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-1 mb-3"
      :search="search"
      :items-per-page="10"
      :loading="loading"
      :loading-text="loadingText"
      :no-data-text="noAffiliates"
      :footer-props="{
        'items-per-page-text': this.$t('rowsPerPage'),
      }"
    >
      <!-- <template v-for="h in headers" v-slot:[`header.${h.value}`]="{}">
        <div :key="h.value">
          <span>{{ h.text }}</span>
          <v-tooltip top v-if="h.value === 'bound_player'">
            <template v-slot:activator="{ on }">
              <v-icon color="primary" v-on="on" small class="pl-2">
                mdi-information-outline
              </v-icon>
            </template>
            <span v-html="$t('payments.eligibleForPayment')" />
          </v-tooltip>
        </div>
      </template> -->

      <template v-slot:item.invoice_id="{ item }">
        <v-btn x-small @click="$copy(item.invoice_id)">
          {{ item.invoice_id }}
        </v-btn>
      </template>

      <template v-slot:item.affiliate_id="{ item }">
        <v-btn x-small @click="$copy(item.affiliate_id)">
          {{ item.affiliate_id }}
        </v-btn>
      </template>

      <template v-slot:item.paid_invoice_date="{ item }">
        {{
          item.paid_invoice_date
            ? new Date(
                item.paid_invoice_date.replace(" ", "T")
              ).toLocaleString()
            : ""
        }}
      </template>

      <template v-slot:item.affiliate_name="{ item }">
        <a
          class="blue--text"
          @click="
            $profile.showProfileDrawer(
              item.affiliate_id,
              `/${$prefix()}/affiliates/getAffiliate`
            )
          "
        >
          <v-icon color="blue" small>mdi-account</v-icon>
          {{ item.affiliate_name }} <small>({{ item.affiliate_id }})</small>
        </a>
      </template>

      <template v-slot:item.local_name="{ item }">
        <a
          class="green--text"
          @click="
            $profile.showProfileDrawer(
              item.local_id,
              `/${$prefix()}/affiliates/getLocal`
            )
          "
        >
          <v-icon color="green" small>mdi-account-multiple</v-icon>
          {{ item.local_name }} <small>({{ item.local_id }})</small>
        </a>
      </template>

      <template v-slot:item.regional_name="{ item }">
        <a
          class="orange--text"
          @click="
            $profile.showProfileDrawer(
              item.regional_id,
              `/${$prefix()}/affiliates/getRegional`
            )
          "
        >
          <v-icon color="orange" small>mdi-account-tie</v-icon>
          {{ item.regional_name }} <small>({{ item.regional_id }})</small>
        </a>
      </template>

      <template v-slot:item.bound_player="{ item }">
        <v-icon small color="green">
          mdi-check
        </v-icon>
        <a style="cursor: pointer;" @click="toPlayer(item)">
          {{ item.player_login }}
        </a>
      </template>

      <template v-slot:item.ngr_value="{ item }">
        <span class="green--text">
          {{ getPortugueseMoney(item.ngr_value) }}
        </span>
      </template>

      <template v-slot:item.ggr_value="{ item }">
        <span class="green--text">
          {{ getPortugueseMoney(item.ggr_value) }}
        </span>
      </template>

      <template v-slot:item.gross_value="{ item }">
        <span class="green--text">
          {{ getPortugueseMoney(item.gross_value) }}
        </span>
      </template>

      <template v-slot:item.rev_share_value="{ item }">
        <span
          :class="
            Number(item.rev_share_value) == 0 ? 'grey--text' : 'red--text'
          "
        >
          {{ getPortugueseMoney(item.rev_share_value) }}
        </span>
      </template>

      <template v-slot:item.cpa_commission="{ item }">
        <span
          :class="Number(item.cpa_commission) == 0 ? 'grey--text' : 'red--text'"
        >
          {{ getPortugueseMoney(item.cpa_commission) }}
        </span>
      </template>

      <template v-slot:item.commission_value="{ item }">
        <span class="red--text">
          {{ getPortugueseMoney(item.commission_value) }}
        </span>
      </template>

      <template v-slot:item.prize_value="{ item }">
        <span
          :class="Number(item.prize_value) == 0 ? 'grey--text' : 'red--text'"
        >
          {{ getPortugueseMoney(item.prize_value) }}
        </span>
      </template>

      <template v-slot:item.fee_value="{ item }">
        <span :class="Number(item.fee_value) == 0 ? 'grey--text' : 'red--text'">
          {{ getPortugueseMoney(item.fee_value) }}
        </span>
      </template>

      <template v-slot:item.value="{ item }">
        <span class="red--text">
          {{ getPortugueseMoney(item.value) }}
        </span>
      </template>
    </v-data-table>

    <div v-if="Object.keys(resume).length > 0">
      <Resume :resume="resume" :resumePrint="resumePrint" />
    </div>
  </div>
</template>

<script>
import Resume from "../resume";

export default {
  data: () => ({
    items: [],
    search: "",
    resumePrint: "",
    loading: false,
    resume: {},
  }),

  components: { Resume },

  watch: {
    saveFilters(val) {
      val && this.fetchPaymentHistory();
    },
  },

  computed: {
    headers() {
      const headers = [
        { text: this.$t("payments.invoiceId"), value: "invoice_id" },
        {
          text: this.$t("payments.paymentDate"),
          value: "paid_invoice_date",
        },
        { text: this.$t("affiliateName"), value: "affiliate_name" },
        { text: this.$t("payments.linkedPlayer"), value: "bound_player" },
        {
          text: this.$t("revenues"),
          value: "gross_value",
          align: "start",
        },
        {
          text: this.$t("awards"),
          value: "prize_value",
          align: "start",
        },
        {
          text: "GGR",
          value: "ggr_value",
          align: "start",
        },
        {
          text: this.$t("feeValue"),
          value: "fee_value",
          align: "start",
        },
        {
          text: "NGR",
          value: "ngr_value",
          align: "start",
        },
      ];

      const showCpa = false;
      if (showCpa) {
        headers.push(
          {
            text: this.$t("revShareValue"),
            value: "rev_share_value",
            align: "no-wrap",
          },
          {
            text: this.$t("valueCpa"),
            value: "cpa_commission",
            align: "no-wrap",
          }
        );
      }

      headers.push({
        text: this.$t("commissionValue"),
        value: "value",
      });

      return headers;
    },
    regionalId() {
      return this.$store.state.filters.autocompleteRegionals.id;
    },
    localId() {
      return this.$store.state.filters.autocompleteLocals.id;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    refresh() {
      return this.$store.getters.getRefresh;
    },
    loadingText() {
      return this.$t("payments.loadingAffiliates");
    },
    noAffiliates() {
      return this.$t("payments.noDataFound");
    },
  },

  methods: {
    fetchPaymentHistory() {
      this.search = "";
      this.items = [];
      this.resume = {};

      const { year, month } = this.$store.getters.getMonthAndYearOfPayment;

      const body = {
        regional_id: this.regionalId,
        local_id: this.localId,
        year,
        month,
      };

      this.loading = true;

      this.$axios
        .post(
          `/${this.$prefix()}/financial/paidAffiliateHistory`,
          this.$formdata(body)
        )
        .then((res) => {
          this.items = res.data.dados;

          this.items = this.items.map((item) => {
            const ggr_value =
              Number(item.gross_value) - Number(item.prize_value);
            const fee_percentage = Number(item.fee_percentage) / 100;
            const fee_value =
              ggr_value > 0 ? Number(ggr_value) * fee_percentage : 0;
            const ngr_value = Number(item.ngr);

            return {
              ...item,
              rev_share_value: (
                Number(item.value) - Number(item.cpa_commission)
              ).toFixed(2),
              ggr_value: ggr_value.toFixed(2),
              fee_value: fee_value.toFixed(2),
              ngr_value: ngr_value.toFixed(2),
            };
          });

          this.buildResume();
        })
        .catch(() => {
          this.items = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    buildResume() {
      const resume = {};

      resume.affiliates_count = { classColor: "", value: this.items.length };

      resume.gross_value = this.getResumeItem({
        key: "gross_value",
      });

      resume.prize_value = this.getResumeItem({
        key: "prize_value",
      });

      resume.ggr_value = this.getResumeItem({
        key: "ggr_value",
      });

      resume.fee_value = this.getResumeItem({
        key: "fee_value",
      });

      resume.ngr_value = this.getResumeItem({
        key: "ngr_value",
      });

      resume.historyValue = this.getResumeItem({ key: "value" });

      const resumePrint = `
        <table>
          <tr>${resume.affiliates_count.value.toString().replace(".", ",")}</tr>
          <tr>${resume.gross_value.value.toString().replace(".", ",")}</tr>
          <tr>${resume.prize_value.value.toString().replace(".", ",")}</tr>
          <tr>${resume.ggr_value.value.toString().replace(".", ",")}</tr>
          <tr>${resume.fee_value.value.toString().replace(".", ",")}</tr>
          <tr>${resume.ngr_value.value.toString().replace(".", ",")}</tr>
          <tr>${resume.historyValue.value.toString().replace(".", ",")}</tr>
        </table>
        `;

      this.resumePrint = resumePrint;

      this.resume = resume;
    },
    getResumeItem({ key }) {
      const value = this.items
        .reduce((n, item) => n + Number(item[key]), 0)
        .toFixed(2);

      return {
        value: this.getPortugueseMoney(value),
        valueWithoutFormat: value,
      };
    },
    toPlayer(item) {
      const prefix =
        this.$prefix() === "colab" ? "Collaborator" : "Administrator";

      const routeName = `${prefix}AccountabilityOnlinePlayersOnlineSearch`;

      this.$router.push({
        name: routeName,
        query: { id_user: item.bound_player },
      });
    },
    getPortugueseMoney(value) {
      return Number(value).toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
      });
    },
  },
};
</script>
